import type { InputHTMLAttributes } from 'react';
import { classNames } from './classNames';
import { habitaControlBorderClass } from './HabitaSurface';

interface HabitaSearchInputProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange' | 'type' | 'value'> {
  containerClassName?: string;
  inputClassName?: string;
  onValueChange?: (value: string) => void;
  value?: string;
}

function hasExplicitContainerWidth(className: string | undefined): boolean {
  return Boolean(className?.match(/(?:^|\s)!?(?:w-|basis-|flex-1|flex-auto|flex-initial|flex-none)/));
}

export function HabitaSearchInput({
  containerClassName,
  inputClassName,
  onValueChange,
  value,
  ...props
}: HabitaSearchInputProps) {
  return (
    <div className={classNames('relative', !hasExplicitContainerWidth(containerClassName) && 'w-full', containerClassName)}>
      <i
        className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-base text-textSecondary"
        aria-hidden
      />
      <input
        {...props}
        type="search"
        value={value}
        onChange={(event) => onValueChange?.(event.target.value)}
        className={classNames(
          `w-full rounded-md border ${habitaControlBorderClass} bg-card py-2 pl-9 pr-3 font-instrument text-sm text-textPrimary outline-none transition-colors placeholder:text-textSecondary/70 focus:border-primary focus:ring-2 focus:ring-primary/20`,
          inputClassName
        )}
      />
    </div>
  );
}
